import { TranslateService } from '@ngx-translate/core';
import { ProcessStatusGql } from '@iss/libs/graphql';
import { ChangeDetectorRef, Pipe, PipeTransform } from '@angular/core';

import { BaseEnumTranslationPipe } from './base-enum-translation.pipe';

@Pipe({ name: 'processState', pure: false, standalone: true })
export class ProcessStatePipe extends BaseEnumTranslationPipe<ProcessStatusGql> implements PipeTransform{
  protected readonly translationPrefix = 'process-state';

  public constructor(translateService: TranslateService, changeDetectorRef: ChangeDetectorRef) {
    super(translateService, changeDetectorRef);
  }
}
